module.exports = __webpack_public_path__ + "static/img/icon-find-success.b2f3a966.png";